<template lang="pug">
.signatures-list
  ul.mb-0
    li.signature-item(:key='signer.id' v-for='signer in signers')
      .signature-name.text-overflow-ellipse(:title='signer.addressees[0].name')
        span {{ signer.addressees[0].name }}
      .signature-status(
        :class='signer.state'
        v-if='!currentDocument || signsCurrentDocument(signer)'
      )
        icon-status(:icon-status='signer.state')
        span.text.ms-2(style='font-weight: 600') {{ $t('signaturesList.recipientType', { type: $t(`signaturesList.recipientTypes.${signer.type}`) }) }}
        | {{ $t('signaturesList.recipientState', { state: $t(`signaturesList.recipientStates.${signer.state}`) }) }}
      .signature-status(v-if='currentDocument && isSignerType(signer)')
        info-pill(
          :active='signsCurrentDocument(signer)'
          :icon='signsCurrentDocument(signer) ? "signature" : "eye"'
        ) {{ signsCurrentDocument(signer) ? $t('modal.envelope.isSignerInDocument') : $t('modal.envelope.isNotSignerInDocument') }}
    li.signature-item
      .signature-status(:class='envelope.state')
        icon-status(:icon-status='envelope.state')
        span.text.ms-2(style='font-weight: 600') {{ $t('signaturesList.envelopeState', { state: envelopeStateText }) }}
      .signature-name {{ $t('signaturesList.envelopeDescription', { description: envelopeStateDescription }) }}
</template>

<script>
import IconStatus from '@/ui/atoms/IconStatus.vue';
import InfoPill from '@/modules/business/components/molecules/InfoPill.vue';
import RecipientState from '@/enums/RecipientState';
import RecipientType from '@/enums/RecipientType';
import EnvelopeState from '@/enums/EnvelopeState';

export default {
  name: 'signaturesList',
  components: {
    IconStatus,
    InfoPill,
  },
  props: {
    envelope: {
      type: Object,
      required: true,
    },
    currentDocument: {
      type: Object,
      default: null,
    },
  },
  computed: {
    signers() {
      const signers = this.envelope.recipients.filter(
        (recipient) => recipient.type !== RecipientState.CARBON_COPY
      );
      return signers.sort((a, b) => a.routing_order - b.routing_order);
    },
    envelopeStateText() {
      return EnvelopeState.getText(
        this.envelope.state,
        this.$i18n
      ).toLowerCase();
    },
    envelopeStateDescription() {
      return EnvelopeState.getDescription(
        this.envelope.state,
        this.$i18n
      ).toLowerCase();
    },
  },
  methods: {
    signsCurrentDocument(signer) {
      if (!this.currentDocument) {
        return false;
      }
      return !(signer.exclude_documents ?? []).includes(
        this.currentDocument.id
      );
    },
    isSignerType(signer) {
      return (
        signer.type === RecipientType.SIGNER ||
        signer.type === RecipientType.IN_PERSON_SIGNER
      );
    },
  },
};
</script>

<style scoped lang="stylus">
.signatures-list
    ul
      margin: 0 0 20px 0
      padding: 1rem
      list-style: none
      border: 1px solid rgba(204, 204, 204, .7)
      border-radius: 5px

      li
        padding: 0.75rem 0
        border-bottom: 1px solid rgba(204, 204, 204, .7)
        height: auto

        &:first-child
          padding-top: 0

        &:last-child
          padding-bottom: 0
          border-bottom: none

        .signature-status
          display: flex
          flex-wrap: wrap
          align-items: center
          row-gap: 0.35rem

          &.done i
            color: green

          &.waiting i
            color: #F7E60A

          &.rejected i
            color: red

          &.signing i
            color: blue

          span
            font-size: 0.85rem

          .pill
            white-space: normal
            text-align: left
</style>
